export const environment = {
  production: false,
  apiBaseUrl: 'https://api-aibilling.ospbiz.com/api/',
  notificationHubUrl: 'https://api-aibilling.ospbiz.com/notificationHub'
};
